import { EndpointInterface } from '@surglogs-app/network'

import { EndpointProviderDefaults } from './convertEndpointProviderToFetchArgs'
import { createQueryEndpoint } from './createQueryEndpoint'
import { useNetworkContext } from './NetworkProvider'

export const useEndpointFetch = <
  TResponse = any,
  TRequestBody extends Record<string, any> = Record<string, any>,
>({
  endpoint,
  defaults,
  isBlob,
}: {
  endpoint: EndpointInterface<TResponse, TRequestBody>
  defaults: EndpointProviderDefaults | undefined
  isBlob?: boolean
}) => {
  const networkContext = useNetworkContext()
  return createQueryEndpoint(networkContext, { endpoint, defaults, isBlob })
}
